<template>
    <div>
        <CModal
            :title="titleComponent"
            :show="showComponent"
            :color="colorComponent"
            :size="sizeComponent"
        >
            <CContainer fluid class="position-relative">
                <CRow>
                    <CCol>
                        <CustomTable
                            :items.sync="tables.conditions.items"
                            :fields="tables.conditions.fields"
                            v-bind="tables.conditions"
                        >
                            <template #name="{ index }">
                                <CInput
                                    :value.sync="
                                        tables.conditions.items[index].name
                                    "
                                    placeholder="Enter a name"
                                    invalidFeedback="Name is required"
                                    class="mb-0"
                                    size="sm"
                                />
                            </template>
                            <template #condition="{ index }">
                                <CSelect
                                    :value.sync="
                                        tables.conditions.items[index].condition
                                    "
                                    :options="[
                                        'in_list',
                                        'not_in_list',
                                        'equal',
                                        'not_equal',
                                        'greater_than',
                                        'less_than',
                                    ]"
                                    placeholder="Select a condition"
                                    invalidFeedback="A condition is required"
                                    class="mb-0"
                                    size="sm"
                                />
                            </template>
                            <template #value="{ index }">
                                <InputList
                                    v-if="
                                        tables.conditions.items[index]
                                            .condition === 'in_list'
                                    "
                                    :value.sync="
                                        tables.conditions.items[index].value
                                    "
                                    :placeholder="'Enter the value'"
                                    :block="true"
                                    size="sm"
                                />
                                <CInput
                                    v-else
                                    :value.sync="
                                        tables.conditions.items[index].value
                                    "
                                    placeholder="Enter a value"
                                    invalidFeedback="Value is required"
                                    class="mb-0"
                                    size="sm"
                                />
                            </template>
                            <template #options="{ index }">
                                <div class="table-options">
                                    <CButton
                                        color="danger"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="
                                            deleteItemToTable(
                                                'conditions',
                                                index
                                            )
                                        "
                                    >
                                        <CIcon
                                            class="icon"
                                            :content="$options.icons.cilTrash"
                                        />
                                    </CButton>
                                </div>
                            </template>
                            <template #no-items-view>
                                <div class="block-no-items section">
                                    <h2 class="section__title text-no-items">
                                        Add a new item
                                    </h2>
                                    <CButton
                                        color="success"
                                        class="button m-2 shadow"
                                        @click="addItemToTable('conditions')"
                                    >
                                        <span class="button__icon">
                                            <CIcon
                                                :content="
                                                    $options.icons.cilPlus
                                                "
                                            />
                                        </span>
                                        <span class="button__text">
                                            {{ "add" }}
                                        </span>
                                    </CButton>
                                </div>
                            </template>
                            <template #under-table>
                                <CButton
                                    color="success"
                                    class="button m-2 shadow"
                                    @click="addItemToTable('conditions')"
                                    v-if="tables.conditions.items.length > 0"
                                >
                                    <span class="button__icon">
                                        <CIcon
                                            :content="$options.icons.cilPlus"
                                        />
                                    </span>
                                    <span class="button__text">
                                        {{ "add" }}
                                    </span>
                                </CButton>
                            </template>
                        </CustomTable>
                    </CCol>
                </CRow>
            </CContainer>
            <template #footer>
                <CButton color="secondary" @click="closeModal()">
                    Cancel
                </CButton>
                <CButton color="success" @click="save()"> Save </CButton>
            </template>
        </CModal>
        <button
            @click="openModal"
            :class="[
                'gjs-btn-prim',
                {
                    'gjs-btn--full': btnFull,
                },
            ]"
        >
            {{ btnText }}
        </button>
    </div>
</template>

<script>
import {
    cilPlus,
    cilSettings,
    cilStorage,
    cilCopy,
    cilTrash,
    cilArrowBottom,
    cilArrowTop,
    cilWarning,
} from "@coreui/icons";

import InputList from "~/components/InputList";

import CustomTable from "~/components/CustomTable";
import tableMixin from "~/mixins/table.js";

import FilterTypeOptions from "~/pages/app/config/options/filter_type";
import { CButton } from "@coreui/vue";

export default {
    name: "ModalConditios",
    mixins: [tableMixin],
    icons: {
        cilPlus,
        cilSettings,
        cilStorage,
        cilCopy,
        cilTrash,
        cilArrowBottom,
        cilArrowTop,
        cilWarning,
    },
    options: {
        FilterTypeOptions,
    },
    components: {
        CustomTable,
        InputList,
    },
    data: function () {
        return {
            titleComponent: null,
            showComponent: false,
            colorComponent: "primary",
            sizeComponent: "lg",
            tables: {
                conditions: {
                    fields: [
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "condition",
                            label: "condition",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "value",
                            label: "value",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "options",
                            label: "",
                            sorter: false,
                            filter: false,
                        },
                    ],
                    items: [],
                    order: "asc",
                    page: 1,
                    rows: 5,
                    total_pages: 1,
                    loading: false,
                    hover: true,
                    pagination: true,
                    sorter: true,
                    dark: false,
                    resizable: false,
                    itemsPerPageSelect: false,
                },
            },
        };
    },
    props: {
        title: {
            type: String,
            default: "Conditions",
        },
        show: Boolean,
        color: {
            type: String,
            default: "primary",
        },
        size: {
            type: String,
            default: "lg",
        },
        btnText: {
            default: "¡Click here!",
        },
        btnFull: {
            default: false,
        },
    },
    watch: {
        title() {
            this.titleComponent = this.title;
        },
        show() {
            this.showComponent = this.show;
        },
        color() {
            this.colorComponent = this.color;
        },
        size() {
            this.sizeComponent = this.size;
        },
        showComponent() {
            this.$emit("update:show", this.showComponent);
        }
    },
    methods: {
        closeModal() {
            this.showComponent = false;
        },
        openModal() {
            this.showComponent = true;
        },

        save() {
            this.$emit("save");
            this.closeModal();
        },

        setConditions(conditions) {
            this.tables.conditions.items = conditions;
        },
        getConditions() {
            return this.tables.conditions.items;
        },
    },
    async mounted() {
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
    async created() {},
};
</script>

<style lang="scss">
.modal_editor__dropdown {
    & .dropdown-toggle {
        background: transparent !important;
    }
}

.gjs-mdl-container-overlay {
    background-color: #463a3c !important;
    z-index: 1600;
}
</style>
